import { getCookie } from '@amagimedia/api-client';
import { REFRESH_TOKEN_KEY } from '@amagimedia/api-client/src/constants';
import { RefreshTokenKeyCookie } from '@amagimedia/api-client/src/types';
import axios from 'axios';
import { ApiClientStvV2 } from '../ApiClientStvV2';
import { BACKEND_API_URL_V3 } from '../constants';

const AuthClient = axios.create({
  baseURL: BACKEND_API_URL_V3,
});

const defaultErrorMessage = {
  response: {
    data: {
      error: 'Something happened. Please try again later',
    },
  },
};

AuthClient.interceptors.request.use(
  (config) => config,
  () => {
    return Promise.reject(defaultErrorMessage);
  },
);

AuthClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.data &&
      (error.response.data.error || error.response.data.errors)
    ) {
      return Promise.reject(error);
    }
    return Promise.reject(defaultErrorMessage);
  },
);

export const signInStvV2 = (domain: string) => {
  window.location.assign(
    `${BACKEND_API_URL_V3}/fabric/api/v3/signin?domain=${domain}`,
  );
};

export function deleteStvV2Token() {
  const refreshTokenDetails =
    getCookie<RefreshTokenKeyCookie>(REFRESH_TOKEN_KEY);
  if (refreshTokenDetails === null) {
    throw new Error('Auth details are empty');
  }
  return ApiClientStvV2.delete('/fabric/api/v3/token', {
    headers: {
      'x-refresh-token': refreshTokenDetails.refresh_token,
    },
  });
}

export function logoutStvV2() {
  return ApiClientStvV2.get('/fabric/api/v3/signout');
}
